import { render, staticRenderFns } from "./StartForm17.vue?vue&type=template&id=082c0cb6&scoped=true"
import script from "./StartForm17.vue?vue&type=script&lang=ts"
export * from "./StartForm17.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082c0cb6",
  null
  
)

export default component.exports